import type {WebSocketMessage} from './streaming-interfaces';

export enum StreamEventType {
    READY,
    NOT_READY,
    MESSAGE,
    ERROR
}

export interface StreamEvent {
    type: StreamEventType;
    payload?: any;
}

export interface StreamReadyEvent extends StreamEvent {
    type: StreamEventType.READY;
}

export interface StreamNotReadyEvent extends StreamEvent {
    type: StreamEventType.NOT_READY;
}

export interface StreamMessageEvent extends StreamEvent {
    type: StreamEventType.MESSAGE;
    payload: WebSocketMessage;
}

export interface StreamErrorEvent extends StreamEvent {
    type: StreamEventType.ERROR;
    payload: CloseEvent;
}
